@if (!item.hidden) {
  @if (showMenuItems()) {
    @if (
      currentUser.OPENINNEWTAB == 1 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE != 'Authorities' &&
      item.TITLE != 'Searching' &&
      item.TITLE != 'Diary' &&
      item.TITLE != 'Trust Money' &&
      item.TITLE != 'Trust End Of Month' &&
      item.TITLE != 'Safe Custody' &&
      item.TITLE != 'Tasks' &&
      item.TITLE != 'Inbox'
    ) {
      <a
        class="nav-link"
        (click)="navigateTab(item.URL, item.openInNewTab ? '_blank' : '_self', item.TITLE)"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActive]="['active', 'accent']"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 1 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Authorities' &&
      showAuth
    ) {
      <a
        class="nav-link"
        (click)="navigateTab(item.URL, item.openInNewTab ? '_blank' : '_self', item.TITLE)"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActive]="['active', 'accent']"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 1 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Inbox' &&
      showInboxData
    ) {
      <a
        class="nav-link"
        (click)="navigateTab(item.URL, item.openInNewTab ? '_blank' : '_self', item.TITLE)"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActive]="['active', 'accent']"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 1 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Searching' &&
      showSearching
    ) {
      <a
        class="nav-link"
        (click)="navigateTab(item.URL, item.openInNewTab ? '_blank' : '_self', item.TITLE)"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActive]="['active', 'accent']"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 1 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Trust Money' &&
      showTrustData
    ) {
      <a
        class="nav-link"
        (click)="navigateTab(item.URL, item.openInNewTab ? '_blank' : '_self', item.TITLE)"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActive]="['active', 'accent']"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 1 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Trust End Of Month' &&
      showTrustData
    ) {
      <a
        class="nav-link"
        (click)="navigateTab(item.URL, item.openInNewTab ? '_blank' : '_self', item.TITLE)"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActive]="['active', 'accent']"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 1 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Safe Custody' &&
      showSafeCustodyData
    ) {
      <a
        class="nav-link"
        (click)="navigateTab(item.URL, item.openInNewTab ? '_blank' : '_self', item.TITLE)"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActive]="['active', 'accent']"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 1 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Diary' &&
      showDairy
    ) {
      <a
        class="nav-link"
        (click)="navigateTab(item.URL, item.openInNewTab ? '_blank' : '_self', item.TITLE)"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActive]="['active', 'accent']"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 1 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Tasks' &&
      showshowTaskPipeData
    ) {
      <a
        class="nav-link"
        (click)="navigateTab(item.URL, item.openInNewTab ? '_blank' : '_self', item.TITLE)"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActive]="['active', 'accent']"
        [ngClass]="item.exactMatch ? 'accent' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 0 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE != 'Authorities' &&
      item.TITLE != 'Searching' &&
      item.TITLE != 'Diary' &&
      item.TITLE != 'Trust Money' &&
      item.TITLE != 'Trust End Of Month' &&
      item.TITLE != 'Safe Custody' &&
      item.TITLE != 'Tasks' &&
      item.TITLE != 'Inbox'
    ) {
      <a
        class="nav-link"
        [ngClass]="item.classes"
        [routerLink]="[item.URL]"
        [routerLinkActive]="['active', 'accent']"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 0 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Authorities' &&
      showAuth
    ) {
      <a
        class="nav-link"
        [ngClass]="item.classes"
        [routerLink]="[item.URL]"
        [routerLinkActive]="['active', 'accent']"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 0 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Inbox' &&
      showInboxData
    ) {
      <a
        class="nav-link"
        [ngClass]="item.classes"
        [routerLink]="[item.URL]"
        [routerLinkActive]="['active', 'accent']"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 0 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Searching' &&
      showSearching
    ) {
      <a
        class="nav-link"
        [ngClass]="item.classes"
        [routerLink]="[item.URL]"
        [routerLinkActive]="['active', 'accent']"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 0 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Trust Money' &&
      showTrustData
    ) {
      <a
        class="nav-link"
        [ngClass]="item.classes"
        [routerLink]="[item.URL]"
        [routerLinkActive]="['active', 'accent']"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 0 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Trust End Of Month' &&
      showTrustData
    ) {
      <a
        class="nav-link"
        [ngClass]="item.classes"
        [routerLink]="[item.URL]"
        [routerLinkActive]="['active', 'accent']"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 0 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Safe Custody' &&
      showSafeCustodyData
    ) {
      <a
        class="nav-link"
        [ngClass]="item.classes"
        [routerLink]="[item.URL]"
        [routerLinkActive]="['active', 'accent']"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 0 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Diary' &&
      showDairy
    ) {
      <a
        class="nav-link"
        [ngClass]="item.classes"
        [routerLink]="[item.URL]"
        [routerLinkActive]="['active', 'accent']"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @if (
      currentUser.OPENINNEWTAB == 0 &&
      item.URL &&
      !item.externalURL &&
      !item.function &&
      item.TITLE == 'Tasks' &&
      showshowTaskPipeData
    ) {
      <a
        class="nav-link"
        [ngClass]="item.classes"
        [routerLink]="[item.URL]"
        [routerLinkActive]="['active', 'accent']"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    <!--Old Code uncomment below code and comment upper code in for tab management-->
    <!-- <a class="nav-link" [ngClass]="item.classes" *ngIf="item.URL && !item.externalURL && !item.function" [routerLink]="[item.URL]" [routerLinkActive]="['active', 'accent']" [routerLinkActiveOptions]="{exact: item.exactMatch || false}" [target]="item.openInNewTab ? '_blank' : '_self'">
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>-->
    <!-- item.externalURL -->
    @if (item.URL && item.externalURL && !item.function) {
      <a
        class="nav-link"
        [ngClass]="item.classes"
        [href]="item.URL"
        [target]="item.openInNewTab ? '_blank' : '_self'"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    <!-- item.function -->
    @if (!item.URL && item.function) {
      <span class="nav-link" [ngClass]="item.classes" (click)="item.function()">
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </span>
    }
    <!-- item.URL && item.function -->
    @if (item.URL && !item.externalURL && item.function) {
      <a
        class="nav-link"
        [ngClass]="item.classes"
        (click)="item.function()"
        [routerLink]="[item.URL]"
        [routerLinkActive]="['active', 'accent']"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
        [target]="item.openInNewTab ? '_blank' : '_self'"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    <!-- item.externalURL && item.function -->
    @if (item.URL && item.externalURL && item.function) {
      <a
        class="nav-link"
        [ngClass]="item.classes"
        (click)="item.function()"
        [href]="item.URL"
        [target]="item.openInNewTab ? '_blank' : '_self'"
      >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    <ng-template #itemContent>
      <ng-container>
        <!-- <mat-icon class="nav-link-icon" *ngIf="item.icon">{{item.icon}}</mat-icon> -->
        @if (item.icon) {
          <mat-icon class="nav-link-icon new_matter_svg flex items-center">
            @if (item.TITLE == 'Matters') {
              <img
                src="assets/icons/web_app/Frame 36.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Matters' : ''"
                class="only_matter"
              />
            }
            @if (item.TITLE == 'Contacts') {
              <img
                src="assets/icons/web_app/Contact Base Icon 2.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Contacts' : ''"
              />
            }
            @if (item.TITLE == 'Time entries') {
              <img
                src="assets/icons/web_app/Timer Base Icon2.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Time entries' : ''"
              />
            }
            @if (item.TITLE == 'Diary' && showDairy) {
              <img
                src="assets/icons/web_app/diary base icon.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Diary' : ''"
              />
            }
            @if (item.TITLE == 'Invoices') {
              <img
                src="assets/icons/web_app/Invoice Icon Base Style.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Invoices' : ''"
              />
            }
            @if (item.TITLE == 'Spend money') {
              <img
                src="assets/icons/web_app/Spend Money Base Icon2.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Spend money' : ''"
              />
            }
            @if (item.TITLE == 'Receive money') {
              <img
                src="assets/icons/web_app/Receive Money Icon.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Receive money' : ''"
              />
            }
            @if (item.TITLE == 'Generate document') {
              <img
                src="assets/icons/web_app/Document_Templates_Icon.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Generate document' : ''"
              />
            }
            @if (item.TITLE == 'Authorities' && showAuth) {
              <img
                src="assets/icons/web_app/Authorities Base Icon.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Authorities' : ''"
              />
            }
            @if (item.TITLE == 'Tasks' && showshowTaskPipeData) {
              <img
                src="assets/icons/web_app/Tasks Icon Base Style dark mode.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Tasks' : ''"
              />
            }
            @if (item.TITLE == 'Searching') {
              <img
                src="assets/icons/web_app/searching base darkmode.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Searching' : ''"
              />
            }
            @if (item.TITLE == 'Safe Custody' && showSafeCustodyData) {
              <img
                src="assets/icons/web_app/Safe Custody Base Style.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Safe Custody' : ''"
              />
            }
            @if (item.TITLE == 'Trust Money' && showTrustData) {
              <img
                src="assets/icons/web_app/Trust Icon Base Style.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Trust Money' : ''"
              />
            }
            @if (item.TITLE == 'Trust End Of Month' && showTrustData) {
              <img
                src="assets/icons/web_app/Trust End of Month.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Trust End Of Month' : ''"
              />
            }
            @if (item.TITLE == 'Conflict Check') {
              <img
                src="assets/icons/web_app/Conflict_Check_Icon.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Conflict Check' : ''"
              />
            }
            @if (item.TITLE == 'Inbox' && showInboxData) {
              <img
                src="assets/icons/web_app/base icon.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Inbox' : ''"
              />
            }
            <!-- assets/icons/web_app/icon_reports_d.ico -->
            @if (item.TITLE == 'Dashboard') {
              <img
                src="assets/icons/web_app/dashboard2.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Dashboard' : ''"
              />
            }
            @if (item.TITLE == 'Bank Feeds') {
              <img
                src="assets/icons/web_app/Frame 118.svg"
                data-toggle="tooltip"
                data-placement="top"
                [title]="isCollapsed ? 'Bank Feeds' : ''"
              />
            }
            <!-- <img *ngIf="item.TITLE=='Trust Banking'" src="assets/icons/web_app/icon_trust_d.ico"  > -->
          </mat-icon>
        }
        <!-- {{item | json}} -->
        @if (
          item.TITLE != 'Authorities' &&
          item.TITLE != 'Diary' &&
          item.TITLE != 'Trust Money' &&
          item.TITLE != 'Trust End Of Month' &&
          item.TITLE != 'Safe Custody' &&
          item.TITLE != 'Tasks' &&
          item.TITLE != 'Inbox'
        ) {
          <span class="nav-link-title">{{ item.TITLE }}</span>
        }
        @if (item.TITLE == 'Authorities' && showAuth) {
          <span class="nav-link-title">{{ item.TITLE }}</span>
        }
        @if (item.TITLE == 'Inbox' && showInboxData) {
          <span class="nav-link-title">{{ item.TITLE }}</span>
        }
        @if (item.TITLE == 'Diary' && showDairy) {
          <span class="nav-link-title">{{ item.TITLE }}</span>
        }
        @if (item.TITLE == 'Trust Money' && showTrustData) {
          <span class="nav-link-title">{{ item.TITLE }}</span>
        }
        @if (item.TITLE == 'Trust End Of Month' && showTrustData) {
          <span class="nav-link-title">{{ item.TITLE }}</span>
        }
        @if (item.TITLE == 'Safe Custody' && showSafeCustodyData) {
          <span class="nav-link-title">{{ item.TITLE }}</span>
        }
        @if (item.TITLE == 'Tasks' && showshowTaskPipeData) {
          <span class="nav-link-title">{{ item.TITLE }}</span>
        }
        @if (item.badge) {
          <span
            class="nav-link-badge"
            [translate]="item.badge.translate"
            [ngStyle]="{ 'background-color': item.badge.bg, color: item.badge.fg }"
          >
            {{ item.badge.TITLE }}
          </span>
        }
        <!-- <mat-icon  *ngIf= 'ToggleData ' (click)="onChange(item.TITLE)" class="star nav-link-title"></mat-icon> -->
        <!-- <mat-icon  *ngIf="ToggleData == true || ToggleData == 'true'" (click)="onChange(item.TITLE); preventDefault($event);" class="star nav-link-title">
    {{"item.STAR == 'star'"?item.STAR:''}}</mat-icon> -->
        @if (ToggleData == true || ToggleData == 'true') {
          @if (item.STAR != 'star') {
            <mat-icon
              (click)="onChange(item.TITLE); preventDefault($event)"
              class="star nav-link-title"
            >
              star_border
            </mat-icon>
          }
          @if (item.STAR == 'star') {
            <mat-icon
              (click)="onChange(item.TITLE); preventDefault($event)"
              class="star nav-link-title"
            >
              star
            </mat-icon>
          }
        }
      </ng-container>
    </ng-template>
    <!-- <mat-icon class="nav-link-icon nav-link-icon-div" (click)="onChange(item.TITLE)">delete_forever</mat-icon> -->
  }
}
